export default "__VITE_ASSET__9cgJjn07__"